import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, createBlock as _createBlock, renderSlot as _renderSlot, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex-between py-8" }
const _hoisted_2 = { class: "text-22 font-medium text-black-900 tablet:text-26" }
const _hoisted_3 = { class: "flex items-center gap-x-18" }
const _hoisted_4 = {
  key: 0,
  class: "text-14 text-black-400 tablet:text-18"
}
const _hoisted_5 = {
  type: "button",
  class: "modal-popup__close"
}
const _hoisted_6 = { class: "relative mb-12 w-full gap-x-8 rounded-4 border border-dashed border-black-300 bg-black-50 px-8 py-12 text-center text-14 text-black-900" }
const _hoisted_7 = { class: "pr-16 leading-6" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "relative mb-16" }
const _hoisted_12 = ["value", "max"]
const _hoisted_13 = { class: "relative aspect-square w-44 rounded-circle border border-black-200 bg-white" }
const _hoisted_14 = { class: "-mx-16 flex flex-col overflow-y-auto px-16 tablet:-mx-24 tablet:px-24" }
const _hoisted_15 = { class: "mt-auto rounded border border-black-300 p-16 text-14 tablet:text-16" }
const _hoisted_16 = {
  key: 0,
  class: "flex items-center justify-between border-b border-black-200 pb-8 text-black-900"
}
const _hoisted_17 = { class: "flex items-center gap-x-4" }
const _hoisted_18 = { class: "text-black-900" }
const _hoisted_19 = { class: "flex items-center justify-between border-b border-black-200 py-8 tablet:border-none" }
const _hoisted_20 = {
  id: "cartSubtotal",
  class: "font-medium"
}
const _hoisted_21 = {
  key: 0,
  class: "flex items-center justify-between border-b border-black-200 py-8 tablet:border-none"
}
const _hoisted_22 = { class: "font-medium text-green" }
const _hoisted_23 = { class: "flex items-center justify-between py-8 tablet:border-none" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "flex items-center justify-between border-t border-black-200 py-8 text-16 font-medium text-black-900 tablet:text-18" }
const _hoisted_28 = { id: "cartTotal" }
const _hoisted_29 = {
  key: 2,
  class: "center-center absolute text-center"
}
const _hoisted_30 = { class: "text-16" }
const _hoisted_31 = ["href"]
const _hoisted_32 = {
  key: 0,
  class: "block select-none rounded-full bg-black-900 px-[0.4rem] text-center text-12 font-bold text-white"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_cart_drawer_kit_item = _resolveComponent("cart-drawer-kit-item")
  const _component_cart_drawer_item = _resolveComponent("cart-drawer-item")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($data.locale.cart), 1),
      _createElementVNode("div", _hoisted_3, [
        ($options.cartHasItems)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($options.itemsCount) + " " + _toDisplayString($options.itemsCount > 1 ? $data.locale.items : $data.locale.item), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", _hoisted_5, [
          _createVNode(_component_v_icon, {
            icon: "close",
            width: 11,
            height: 11
          })
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, [
        ($options.isDiscountApplicable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString($data.customDiscount.applied_discount_text), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString($options.formattedDiscountRemainingAmountText), 1)
            ], 64))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "absolute right-4 top-4 tablet:right-8 tablet:top-8",
        onClick: _cache[0] || (_cache[0] = $event => ($data.showCustomDiscountPopup = false))
      }, [
        _createVNode(_component_v_icon, {
          icon: "close",
          width: 9,
          height: 9,
          color: "#605F5F"
        })
      ])
    ], 512), [
      [_vShow, $data.showCustomDiscountPopup]
    ]),
    ($options.cartHasItems && $data.isCountryAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["text-center text-14 font-medium text-black-900", {'mb-16': !$options.isShippingAmountReached}])
          }, [
            (!$options.isShippingAmountReached)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($options.shippingAmountLeft) + " " + _toDisplayString($data.locale.shipping_text_progress), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($data.locale.shipping_text_reached), 1))
          ], 2),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("progress", {
              value: $options.total,
              max: $options.formattedShippingThreshold,
              class: "w-full align-middle transition-all duration-500"
            }, null, 8, _hoisted_12),
            _withDirectives(_createElementVNode("div", {
              ref: "progressValueIcon",
              class: "center-y absolute",
              style: _normalizeStyle(`left: ${$options.shippingFollowerPosition}`)
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_v_icon, {
                  icon: "truck",
                  width: 24,
                  height: 24,
                  class: "center-center absolute"
                })
              ])
            ], 4), [
              [_vShow, !$options.isShippingAmountReached]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($options.cartHasItems)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.kitItems, (item) => {
              return (_openBlock(), _createBlock(_component_cart_drawer_kit_item, {
                key: item.key,
                item: item
              }, null, 8, ["item"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item) => {
              return (_openBlock(), _createBlock(_component_cart_drawer_item, {
                key: item.key,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            ($options.isDiscountApplicable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_v_icon, {
                      icon: "gift",
                      width: 22,
                      height: 22
                    }),
                    _createElementVNode("span", null, _toDisplayString($data.locale.code) + ": ", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-medium uppercase", $data.skeletonClass])
                    }, _toDisplayString($options.formattedDiscountCode), 3)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = (...args) => ($options.removeCustomDiscountCode && $options.removeCustomDiscountCode(...args)))
                  }, [
                    _createVNode(_component_v_icon, {
                      icon: "close",
                      width: 9,
                      height: 9,
                      color: "#605F5F"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString($data.locale.subtotal), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString($options.formattedPrice($options.subtotal)), 1)
              ]),
              ($options.isDiscountApplicable || $options.discountValue > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString($data.locale.discount_total), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString($options.formattedDiscountValue), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                ($data.isCountryAvailable)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($options.isShippingAmountReached)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString($data.locale.shipping_fee_reached), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($data.locale.shipping_fee_progress), 1))
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($data.locale.shipping_fee_reached), 1)),
                _createElementVNode("span", {
                  id: "cartShipping",
                  class: _normalizeClass(["text-right font-medium", {'text-green': $options.isShippingAmountReached}])
                }, _toDisplayString($options.formattedShippingValue), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("span", null, _toDisplayString($data.locale.total), 1),
              _createElementVNode("span", _hoisted_28, _toDisplayString($options.formattedPrice($options.total)), 1)
            ]),
            _createElementVNode("a", {
              class: "btn btn-primary btn-small btn-lock__before mt-8 w-full",
              href: "/checkout",
              onClick: _cache[2] || (_cache[2] = (...args) => ($options.setCheckoutEvent && $options.setCheckoutEvent(...args)))
            }, _toDisplayString($data.locale.to_checkout), 1),
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_29, [
          _createElementVNode("span", _hoisted_30, _toDisplayString($data.locale.cart_empty), 1),
          ($data.emptyCartRedirectUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: $data.emptyCartRedirectUrl,
                class: "btn btn-primary btn-small mt-16"
              }, _toDisplayString($data.locale.cart_shop_now), 9, _hoisted_31))
            : _createCommentVNode("", true)
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#cart-count-badge" }, [
      ($options.itemsCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString($options.itemsCount), 1))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}